
<div class="setConfigurator">
  <v-stepper v-model="step" vertical :non-linear="true" class="configurationStepper">
    <v-stepper-step v-if="personSelectionNeeded"
                    :complete="step > personSelectionStep"
                    :step="personSelectionStep"
                    edit-icon="check"
                    editable
    >{{ $t("CONFIGURATOR_CHOOSE_PERSON") }}
      <small>{{ $t("CONFIGURATOR_CHOOSE_PERSON_HINT") }}</small>
    </v-stepper-step>
    <v-stepper-content v-if="personSelectionNeeded" :step="personSelectionStep">
      <PersonSelector :value="personIndex" @input="selectPerson" :persons="eligiblePersons" @select="onPersonSelect"/>
    </v-stepper-content>

    <v-stepper-step v-if="configurationTypeSelectionNeeded"
                    :complete="step > configurationTypeSelectionStep"
                    :step="configurationTypeSelectionStep"
                    edit-icon="check"
                    editable
    >{{ $t("CONFIGURATOR_CHOOSE_MODE") }}
    </v-stepper-step>
    <v-stepper-content v-if="needsToChooseDetailedConfiguration" :step="configurationTypeSelectionStep">
      <ConfigurationModeSelector :value="configurationMode" @input="selectMode"
                                 :product="product"
                                 ref="modeSelector"
                                 @select="nextStep"/>
    </v-stepper-content>

    <v-stepper-step
        :complete="step > imageSelectionStep"
        :step="imageSelectionStep"
        edit-icon="check"
    >{{ $t("CONFIGURATOR_CHOOSE_IMAGES") }}
    </v-stepper-step>
    <v-stepper-content :step="imageSelectionStep" class="imageStepperContent">
      <MultipleRequirementsSelector v-if="step === imageSelectionStep && (!prefill || priorStepsChosen && person)"
                                    v-model="imageSelection"
                                    class="multipleRequirementImageSelector"
                                    :requirements="imageRequirements"
                                    :person="person"
                                    :detailed-configuration="isDetailedConfiguration"
                                    :preserve-prefilled-choices="!!prefill"
                                    ref="imageSelector"/>
    </v-stepper-content>
  </v-stepper>
  <v-row class="actionButtons" justify="center">
    <v-col cols="auto">
      <v-btn v-if="configurationComplete" color="primary" class="actionButton"  :loading="adding" :disabled="adding" @click="addToBasket">
        <v-icon>{{ basketProductSubmission && basketProductSubmission.editing ? "save" : "add_shopping_cart" }}</v-icon>
        {{ $t(basketProductSubmission && basketProductSubmission.editing ? "BASKET_SAVE_CONFIGURATION" : "BUTTON_ADD_TO_BASKET") }}
      </v-btn>
      <v-btn v-else-if="mayShowContinueButton" color="primary" class="actionButton" @click="continueImageSelection">
        {{ $t("BUTTON_CONTINUE") }}
      </v-btn>
    </v-col>
  </v-row>
</div>
